






















































helpers = require('../../helpers.coffee')

view_model =
  props:
    contact:
      default: null

    id:
      default: 'manual-task-form-modal'

  components:
    contactPicker: require('./contact_picker')
    taskForm: require('./form')
    confirmDestroy: require('./confirm_destroy')
    dailyEvents: require('./daily_events')

  data: ->
    current_user: Session.current_user
    removing: false
    filter: null
    task: new Task
    selected_contact: null
    show_stage_selection: false
    add_contact: false
    active_contact: false
    activated_contacts: false
    connected_contact: false
    lost_contact: false
    tasksRealized: false
    selected: null
    optionsList: []
    valid_list: []
    status_options: [
      { value: 'today', text: this.$t('flows.reports.time.today') },
      { value: 'week', text: this.$t('flows.reports.time.week') },
      { value: 'month', text: this.$t('flows.reports.time.month') },
      { value: 'year', text: this.$t('flows.reports.time.year') }
    ],

  computed:
    show_calendar: ->
      true

  methods:
    sending: ->
      data = this.getStartOfMonth(@selected)
      params = {
        id: @$route.params.id
        users_id: Session.current_user.id,
        flow_id: @$route.params.id, 
        company_id: Session.current_company.id
        date_start: data[0]
        date_end: data[1]
        options: {
          add_contact: this.add_contact
          activated_contacts: this.activated_contacts
          active_contact: this.active_contact
          connected_contact: this.connected_contact
          lost_contact: this.lost_contact
          tasks_realized: this.tasksRealized
        }
      }

      moment.locale('pt-br')
      todos_sao_falsos = (value) -> value == false
      
      if Object.values(params.options).every(todos_sao_falsos)
        alertify.error "Voce precisa selecionar algum relatorio"
        return
  
      new FlowsResource().flow_reports(@loadReportsSuccess, @handleApiErrors, params:params )
    ###
    getStartOfMonth:(month) ->
      currentSelect ='01/'+month
      startDate = new Date(new Date(currentSelect).toLocaleString("en-US", { timeZone: @current_user.timezone }));
      startDate.setDate(1)
      startDate.setHours(0, 0, 0);
      d = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0)
      endDate = new Date(new Date(new Date(d).toLocaleString("en-US", { timeZone: @current_user.timezone }) ).setHours(23, 59, 59)).toISOString()
      return [startDate.toISOString(), endDate]
    ###
    getStartOfMonth: (month) ->
      currentSelect = '01/' + month
      startDate = new Date(new Date(currentSelect).toLocaleString("en-US", { timeZone: @current_user.timezone }))
      startDate.setDate(1)
      startDate.setHours(0, 0, 0)
      endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0)
      endDate.setHours(23, 59, 59)
      return [startDate.toISOString(), endDate.toISOString()]
    resetSelect: ->
      this.add_contact= false
      this.active_contact= false
      this.activated_contacts= false
      this.connected_contact= false
      this.lost_contact= false
      this.tasksRealized= false
      
      jQuery('#defaultCheck1').prop("checked", false)
      jQuery('#defaultCheck2').prop("checked", false)
      jQuery('#defaultCheck3').prop("checked", false)
      jQuery('#defaultCheck4').prop("checked", false)
      jQuery('#defaultCheck5').prop("checked", false)
      jQuery('#defaultCheck6').prop("checked", false)
      jQuery('#defaultCheck7').prop("checked", false)
      
    monthList: ->
      moment.locale(@current_user.extradata['language'])
      listMonths = moment.months()
      engLinst= [ 'January','February','March','April','May','June','July','August','September','October','November','December' ]
      
      currentMonth = listMonths[new Date().getMonth()]+'/'+new Date().getFullYear()

      yearsList=['2022','2023']
      
      for year in yearsList
        for month in listMonths
          @optionsList.push({
            value: engLinst[listMonths.indexOf(month)]+'/'+year, 
            text: month+' '+year,
            currentMonth: false,
            valid: this.validMonths(engLinst[listMonths.indexOf(month)]+'/'+year)
          })

      @optionsList=@optionsList.reverse()
    
    validMonths: (month) ->
      year = month.split('/')[1]
      if parseInt(year) == new Date().getFullYear()
        aux = new Date(month).getMonth()
        if new Date().getMonth() < aux
          return false
        return true
      else
        return true
    gerarListaDeAnos: (anoInicial) ->
      listaAnos = []
      for i in [0...5]
        listaAnos.push(anoInicial + i)
      return listaAnos
    toggleMark: ->
      this.add_contact = !this.add_contact

    toggleactivated_contactsMark: ->
      this.activated_contacts = !this.activated_contacts

    toggleactive_contactMark: ->
      this.active_contact = !this.active_contact

    toggleconnected_contact: ->
      this.connected_contact = !this.connected_contact

    togglelostContactMark: ->
      this.lost_contact = !this.lost_contact
    
    toggletasksRealizedMark: ->
      this.tasksRealized = !this.tasksRealized

    loadReportsSuccess: (data) ->
      @hideFlowModal()
      alertify.success(this.$t('flows.feedback.reportSand') )

    showFlowModal: (data) ->
      @resetSelect()
      jQuery('#dialer-manual-flow-form-modal').modal 'show'

    hideFlowModal: ->
      @resetSelect()
      jQuery('#dialer-manual-flow-form-modal').modal 'hide'


  beforeDestroy: ->
    EventsBus.$off 'ModalFlowForm::Show', @showFlowModal
    EventsBus.$off 'ModalFlowForm::Hide', @hideFlowModal

  mounted: ->
    EventsBus.$on 'ModalFlowForm::Show', @showFlowModal
    EventsBus.$on 'ModalFlowForm::Hide', @hideFlowModal
    moment.locale("en-US")
    this.selected = moment().format('MMMM/YYYY')
    @monthList()
    @resetSelect()


exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/modal_flow.vue